// KeywordSelector Layout Component

import { Box } from '@wix/design-system';
import React from 'react';
import { TagDropdown } from '../../components/TagDropdown/TagDropdown';
import { CoreDomainSearchDataHooks, CoreDomainSearchModule } from '../../module/module';
import s from './Keywords.scss';
import clsx from 'clsx';
export const KeywordSelector = _ref => {
  let _ref$selectedKeywords = _ref.selectedKeywords,
    selectedKeywords = _ref$selectedKeywords === void 0 ? [] : _ref$selectedKeywords,
    _ref$availableKeyword = _ref.availableKeywords,
    availableKeywords = _ref$availableKeyword === void 0 ? [] : _ref$availableKeyword,
    onChange = _ref.onChange;
  const _CoreDomainSearchModu = CoreDomainSearchModule.internals.useTranslations(),
    t = _CoreDomainSearchModu.t;
  const options = availableKeywords.map(keyword => ({
    id: keyword,
    value: keyword
  }));
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: CoreDomainSearchDataHooks.keywordSelector,
    flex: 1,
    minWidth: "180px",
    className: clsx(s.keywordSelector, {
      [s.selected]: selectedKeywords.length > 0
    })
  }, /*#__PURE__*/React.createElement(TagDropdown, {
    fullWidth: true,
    value: selectedKeywords,
    options: options,
    onChange: onChange,
    placeholder: t('core_domain_search.domain_gate.keywords_header')
  }));
};
export default KeywordSelector;
//# sourceMappingURL=KeywordSelector.js.map